import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Input } from '../../components';
import debounce from 'lodash/debounce';

import messages from './messages';

class CollegeNameInput extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.object,
    onChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      collegeName: '',
    };
    this.collegeNameDebounce = debounce(this.collegeNameDebounce, 400);
  }

  componentDidUpdate(prevProps) {
    if (this.props.collegeName !== prevProps.collegeName) {
      this.setState({ collegeName: this.props.collegeName || '' });
    }
  }

  collegeNameUpdate = (e, { name, value, id }) => {
    this.setState({ collegeName: value });
    this.collegeNameDebounce(e, { name, value, id });
  };

  collegeNameDebounce = (e, { name, value, id }) => {
    this.props.onChange(e, { name, value, id });
  };

  render() {
    const { intl } = this.props;
    const { collegeName } = this.state;
    return (
      <div>
        <strong>
          <FormattedMessage {...messages.hostedby} />
        </strong>
        <div>
          <Input
            iconPosition="left"
            icon="search"
            data-cy="filter-name"
            onChange={this.collegeNameUpdate}
            type="text"
            name="name"
            id="name"
            value={collegeName || ''}
            placeholder={intl.formatMessage(messages.collegenamefilter)}
            className="hosted-by"
          ></Input>
        </div>
      </div>
    );
  }
}
export default injectIntl(CollegeNameInput);
